import { format, isValid, parse } from "date-fns";

/**
 *
 * @param value datetime in ms
 * @returns string in yyyyMMdd
 */

const checkDDMMYYYY = new RegExp(
  /(((0[1-9])|([12][0-9])|(3[01]))\/((0[0-9])|(1[012]))\/((2\d\d\d|19\d\d|9999)))/
);

// Regex for d/M/yyyy
const checkDMMYYYY = new RegExp(
  /(((0?[1-9])|([12][0-9])|(3[01]))\/((0?[0-9])|(1[012]))\/((2\d\d\d|19\d\d|9999)))/
);

export function parseYYYYMMDD(value: number | string) {
  if (typeof value === "number") {
    return format(
      new Date(Math.round((value - 25569) * 86400 * 1000)),
      "yyyyMMdd"
    );
  }

  return checkDDMMYYYY.test(value)
    ? format(parse(value, "dd/MM/yyyy", new Date()), "yyyyMMdd")
    : "";
}

export function parseDDMMYYYY(value: number | string) {
  if (typeof value === "number") {
    return format(
      new Date(Math.round((value - 25569) * 86400 * 1000)),
      "dd/MM/yyyy"
    );
  }

  // Check regex for DD/MM/YYYY
  if (checkDDMMYYYY.test(value) || checkDMMYYYY.test(value)) {
    return value;
  }

  return "";
}

export function parseYYYYMMDDwithDash(value: number | string) {
  if (typeof value === "number") {
    return format(
      new Date(Math.round((value - 25569) * 86400 * 1000)),
      "yyyy-MM-dd"
    );
  }

  return isValid(parse(value, "dd/MM/yyyy", new Date()))
    ? format(parse(value, "dd/MM/yyyy", new Date()), "yyyy-MM-dd")
    : "";
}
